/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesSubscriptionPlansDtosCreateSubscriptionPlanRequest,
  FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto,
  FacilityFlowCoreModulesSubscriptionPlansDtosUpdateSubscriptionPlanRequest
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getSubscriptionPlans = () => {
const getApiV1SubscriptionPlans = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto[]>(
      {url: `/api/v1/subscription-plans`, method: 'GET'
    },
      options);
    }
  const postApiV1SubscriptionPlans = (
    facilityFlowCoreModulesSubscriptionPlansDtosCreateSubscriptionPlanRequest: FacilityFlowCoreModulesSubscriptionPlansDtosCreateSubscriptionPlanRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>(
      {url: `/api/v1/subscription-plans`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSubscriptionPlansDtosCreateSubscriptionPlanRequest
    },
      options);
    }
  const getApiV1SubscriptionPlansId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>(
      {url: `/api/v1/subscription-plans/${id}`, method: 'GET'
    },
      options);
    }
  const putApiV1SubscriptionPlansId = (
    id: string,
    facilityFlowCoreModulesSubscriptionPlansDtosUpdateSubscriptionPlanRequest: FacilityFlowCoreModulesSubscriptionPlansDtosUpdateSubscriptionPlanRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>(
      {url: `/api/v1/subscription-plans/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSubscriptionPlansDtosUpdateSubscriptionPlanRequest
    },
      options);
    }
  const deleteApiV1SubscriptionPlansId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/subscription-plans/${id}`, method: 'DELETE'
    },
      options);
    }
  const patchApiV1SubscriptionPlansIdActivate = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>(
      {url: `/api/v1/subscription-plans/${id}/activate`, method: 'PATCH'
    },
      options);
    }
  const patchApiV1SubscriptionPlansIdDeactivate = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto>(
      {url: `/api/v1/subscription-plans/${id}/deactivate`, method: 'PATCH'
    },
      options);
    }
  return {getApiV1SubscriptionPlans,postApiV1SubscriptionPlans,getApiV1SubscriptionPlansId,putApiV1SubscriptionPlansId,deleteApiV1SubscriptionPlansId,patchApiV1SubscriptionPlansIdActivate,patchApiV1SubscriptionPlansIdDeactivate}};
export type GetApiV1SubscriptionPlansResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSubscriptionPlans>['getApiV1SubscriptionPlans']>>>
export type PostApiV1SubscriptionPlansResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSubscriptionPlans>['postApiV1SubscriptionPlans']>>>
export type GetApiV1SubscriptionPlansIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSubscriptionPlans>['getApiV1SubscriptionPlansId']>>>
export type PutApiV1SubscriptionPlansIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSubscriptionPlans>['putApiV1SubscriptionPlansId']>>>
export type DeleteApiV1SubscriptionPlansIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSubscriptionPlans>['deleteApiV1SubscriptionPlansId']>>>
export type PatchApiV1SubscriptionPlansIdActivateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSubscriptionPlans>['patchApiV1SubscriptionPlansIdActivate']>>>
export type PatchApiV1SubscriptionPlansIdDeactivateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSubscriptionPlans>['patchApiV1SubscriptionPlansIdDeactivate']>>>
